import styled from "styled-components";
import Callout from "../../components/molecules/Callout";

const Container = styled.div`
  padding-bottom: 24px;
`;

function ScenarioTest() {
  return (
    <Container>
      <p>
        Your proposal to remove native vegetation falls under the{" "}
        <span style={{ fontWeight: 500 }}>Detailed</span> Assessment Pathway.
      </p>
      <p>
        Under this pathway, you are required to engage a certified native
        vegetation assessor to:
      </p>
      <ul>
        <li>
          Complete a site assessment and map the native vegetation you propose
          to remove.
        </li>
        <li>
          Provide advice on how to minimise your impacts, offset requirements
          and costs.
        </li>
        <li>
          Complete a site assessment report, which may be lodged with the
          application for approval.
        </li>
        <li>
          Generate a Native Vegetation Removal Report, using the Detailed Upload
          function.
        </li>
        <li>Provide advice on how to secure an appropriate offset.</li>
      </ul>
      <p>
        If you are seeking an indication of potential offset requirements, you
        may download a Scenario Test report.{" "}
        <span style={{ fontWeight: 500 }}>
          This report cannot be used to support an application.
        </span>
      </p>
      <Callout type="warning" hideIcon>
        <span style={{ fontWeight: 500 }}>
          The offset obligations outlined in Scenario Test reports are
          indicative only and rely on modelled vegetation condition scores.
        </span>
      </Callout>
    </Container>
  );
}

export default ScenarioTest;
